/**
 * @Author: v_jppjpeng
 * @Date: 2023-08-15 20:35:43
 * @Explain: 偏好设置
 */

export default {
  'PREFERENCE.MANAGE.OPTIONS.SETTINGS':
    'Subscriber preferences and <br/> subscription groups',
  'PREFERENCE.MANAGE.OPTIONS.SETTINGS.TIPS':
    'Subscriber preferences tell us the content your contacts are interested in. Contacts can express their interests through subscription groups.',
  'PREFERENCE.MANAGE.HOW.TO.USE': 'How do subscription groups work',
  'PREFERENCE.MANAGE.HOW.TO.USE.TIPS1':
    "Create subscription groups in SmartLink and let your contacts select the ones they're interested in.",
  'PREFERENCE.MANAGE.HOW.TO.USE.TIPS2':
    'Preferences can be set by subscribers themselves or they can be manually set in SmartLink.',
  'PREFERENCE.MANAGE.MAIL.TEMPLATE': 'Email template',
  'PREFERENCE.MANAGE.MAIL.TEMPLATE.TIPS':
    'In your email template, select the option to allow contacts to manage their preferences. Alternatively, you can directly import contacts with specific preferences.',
  'PREFERENCE.MANAGE.SEGMENTS.RULE': 'Segments',
  'PREFERENCE.MANAGE.SEGMENTS.RULE.TIPS':
    'Use the segments function to send targeted campaigns to contacts with specific preferences.',
  'PREFERENCE.MANAGE.CREATE.OPTIONS': 'Create subscription group',
  'PREFERENCE.MANAGE.CREATE.OPTIONS.FIRST': 'Create a subscription group first',
  'PREFERENCE.MANAGE.OPTIONS.NAME': 'Name',
  'PREFERENCE.MANAGE.OPTIONS.NAME.REPETITION': 'Name already exists',
  'PREFERENCE.MANAGE.OPTIONS.NAME.PLACEHOLDER':
    'Enter a name for the subscription group',
  'PREFERENCE.MANAGE.OPTIONS.NAME.NOT.EMPTY': 'Name cannot be empty',
  'PREFERENCE.MANAGE.OPTIONS.NAME.NOT.COMMA': 'Name cannot contain commas',
  'PREFERENCE.MANAGE.OPTIONS.DESC': 'Description',
  'PREFERENCE.MANAGE.OPTIONS.DESC.PLACEHOLDER':
    'Enter a description for this subscription group',
  'PREFERENCE.MANAGE.OPTIONS.DESC.NOT.EMPTY': 'Description cannot be empty',
  'PREFERENCE.MANAGE.IS.SAVE.TITLE': 'Save changes?',
  'PREFERENCE.MANAGE.IS.SAVE.DESC':
    'Changes not yet saved, do you want to save them?',
  'PREFERENCE.MANAGE.IS.DEL.TITLE': 'Delete subscription preference',
  'PREFERENCE.MANAGE.IS.DEL.DESC':
    "<b class='color-333'>'<span>{name}</span>'</b> will be permanently deleted and cannot be restored. This subscription preference will no longer be displayed when contacts update their preferences.",
};
